import * as React from 'react';
import { ICategory } from '../../../interfaces/IFAQPage';
import { FAQCategory } from '../components/FAQCategory';
import parse from 'html-react-parser';

interface IProps {
    faq: ICategory[];
}

export const FAQWrapper = (props: IProps) => {
    const getCategories = props.faq.map((__, key) => {
        const finalName = __.name as string;
        return (
            <FAQCategory
                key={key}
                category_id={__.category_id}
                name={parse(finalName)}
                image={__.image}
                items={__.items}
            />
        );
    });
    return <div>{getCategories}</div>;
};
